import { Helmet } from "react-helmet-async";
import { useEffect, useState } from "react";
import {
  Card,
  Table,
  Stack,
  Paper,
  Button,
  TableRow,
  TableBody,
  TableCell,
  Container,
  Typography,
  TableContainer,
  TableHead,
  CircularProgress,
  Box,
  Tabs,
  Tab,
} from "@mui/material";
import Iconify from "../components/iconify";
import Scrollbar from "../components/scrollbar";
import { useNavigate, useSearchParams } from "react-router-dom";
import { get } from "src/utils/networkUtils";
import { useSelector } from "react-redux";

export default function UserLineupsPage() {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [rows, setRows] = useState(null);
  const [userId, setUserId] = useState(null);
  const [searchParams] = useSearchParams();
  const tenants = useSelector((state) => state.tenant.tenants);
  const selectedTenant = useSelector((state) => state.tenant.selectedTenant);
  const [activeTenantId, setActiveTenantId] = useState(null);

  useEffect(() => {
    // Initialize active tenant when component mounts or selectedTenant changes
    if (selectedTenant && !activeTenantId) {
      setActiveTenantId(selectedTenant.tenantId);
    }
  }, [selectedTenant, activeTenantId]);

  useEffect(() => {
    if (searchParams.has("user_id") && activeTenantId) {
      setLoading(true);
      let userId = searchParams.get("user_id");
      setUserId(userId);
      get(`/admin/lineups?userId=${userId}&tenantId=${activeTenantId}`).then(function (response) {
        setRows(response.lineups);
        setLoading(false);
      });
    } else if (searchParams.has("user_id") && !activeTenantId) {
      // Wait for tenant to be initialized
      let userId = searchParams.get("user_id");
      setUserId(userId);
    } else {
      navigate("/404");
    }
  }, [searchParams, navigate, activeTenantId]);

  const handleTenantChange = (event, newTenantId) => {
    setActiveTenantId(newTenantId);
  };
  return (
    <>
      <Helmet>
        <title> User Lineups </title>
      </Helmet>

      <Container>
        <Stack
          direction="row"
          alignItems="center"
          justifyContent="space-between"
          mb={5}
        >
          <Typography variant="h4" gutterBottom>
            User Lineups
          </Typography>
        </Stack>

        {tenants && tenants.length > 1 && activeTenantId && (
          <Box sx={{ borderBottom: 1, borderColor: 'divider', mb: 3 }}>
            <Stack direction="row" alignItems="center" justifyContent="space-between">
              <Tabs value={activeTenantId} onChange={handleTenantChange}>
                {tenants.map((tenant) => (
                  <Tab
                    key={tenant.tenantId}
                    label={tenant.shortCode}
                    value={tenant.tenantId}
                  />
                ))}
              </Tabs>
              <Button
                variant="contained"
                startIcon={<Iconify icon="eva:plus-outline" />}
                onClick={() =>
                  navigate(`/dashboard/user-football-lineup?user_id=${userId}&tenantId=${activeTenantId}`)
                }
              >
                Create Lineup
              </Button>
            </Stack>
          </Box>
        )}

        <Card>
          {rows === null || loading ? (
            <Box
              sx={{ display: "flex", justifyContent: "center" }}
              style={{ padding: 20 }}
            >
              <CircularProgress />
            </Box>
          ) : (
            <Scrollbar>
              <TableContainer component={Paper}>
                <Table sx={{ minWidth: 650 }} aria-label="simple table">
                  <TableHead>
                    <TableRow>
                      <TableCell>Lineup ID</TableCell>
                      <TableCell>Name</TableCell>
                      <TableCell>Score</TableCell>
                      <TableCell>Start Date</TableCell>
                      <TableCell>End Date</TableCell>
                      <TableCell>Prize Date</TableCell>
                      <TableCell align="right"></TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {rows.map((row, index) => (
                      <TableRow
                        key={index}
                        sx={{
                          "&:last-child td, &:last-child th": { border: 0 },
                        }}
                      >
                        <TableCell component="th" scope="row">
                          {row.lineupId}
                        </TableCell>
                        <TableCell component="th" scope="row">
                          {row.name}
                        </TableCell>
                        <TableCell component="th" scope="row">
                          {row.score}
                        </TableCell>
                        <TableCell component="th" scope="row">
                          {row.startDate}
                        </TableCell>
                        <TableCell component="th" scope="row">
                          {row.endDate}
                        </TableCell>
                        <TableCell component="th" scope="row">
                          {row.paidPrizeAt}
                        </TableCell>
                        <TableCell align="right">
                          <Stack direction="row" spacing={1} justifyContent="flex-end">
                            <Button
                              variant="outlined"
                              onClick={() =>
                                navigate(
                                  `/dashboard/user-football-lineup?lineup_id=${row.lineupId}&user_id=${userId}&tenantId=${activeTenantId}`
                                )
                              }
                            >
                              View Lineup
                            </Button>
                            <Button
                              variant="contained"
                              onClick={() =>
                                navigate(
                                  `/dashboard/user-football-lineup?lineup_id=${row.lineupId}&user_id=${userId}&tenantId=${activeTenantId}`
                                )
                              }
                            >
                              Edit
                            </Button>
                          </Stack>
                        </TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </TableContainer>
            </Scrollbar>
          )}
        </Card>
      </Container>
    </>
  );
}
